<div class="pxl-section">
  <div class="pxl-section-label">🎨 Color</div>
  <div class="palette-container">
    <canvas #spectrumCanvas class="spectrum-canvas"></canvas>
    <canvas #lightnessCanvas class="lightness-strip"></canvas>
    <div class="selected-color">
      <div class="color-box"
        [style.background]="'rgb(' + selectedColor.r + ',' + selectedColor.g + ',' + selectedColor.b + ')'">
      </div>
      <span class="color-hex-val">{{ rgbToHex(selectedColor) }}</span>
    </div>
  </div>
</div>
